import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../utility/Constant";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

// function WorkforceCard({ project, user, handleSingleDelete }) {
//   const { servicesWorkforceList, servicesWorkforceListAdd } = RoutePath;
//   const [showMore, setShowMore] = useState(false);
//   const [visibility, setVisibility] = useState(true);

//   const handleDelete = async () => {
//     const res = await handleSingleDelete(project._id);
//     if (typeof res === "boolean" && res === true) {
//       setVisibility(false);
//     }
//   };

//   return (
//     <>
//       {visibility ? (
//         <div className="group relative border md:min-h-[20rem] flex flex-col overflow-hidden shadow-lg rounded-lg h-full bg-white">
//           {project ? (
//             <>
//               {/* Image */}
//               <figure>
//                 <img
//                   src={project?.Banner_image?.url}
//                   alt={project.Content_Title + " Image"}
//                   className="h-[120px] md:h-[180px] object-cover w-full"
//                 />
//               </figure>

//               {/* Content */}
//               <div className="p-4 flex flex-col flex-grow justify-between gap-3">
//                 {/* Title Section */}
//                 <div>
//                   <span className="block text-sm md:text-base font-medium text-gray-900">
//                     {project.Content_Title}
//                   </span>
//                   <h2 className="mt-1 text-base md:text-lg font-semibold break-words">
//                     {project?.Banner_Title?.length > 20 && !showMore ? (
//                       <>
//                         {project?.Banner_Title?.substring(0, 25)}
//                         <button
//                           onClick={() => setShowMore(true)}
//                           className="text-red-600 hover:text-[#DB0029] ml-1"
//                         >
//                           ...
//                         </button>
//                       </>
//                     ) : (
//                       <>
//                         {project?.Banner_Title}
//                         {project?.Banner_Title?.length > 20 && (
//                           <button
//                             onClick={() => setShowMore(false)}
//                             className="text-red-600 hover:text-[#DB0029] ml-2 text-sm"
//                           >
//                             Show less
//                           </button>
//                         )}
//                       </>
//                     )}
//                   </h2>
//                 </div>

//                 {/* Description */}
//                 <div className="text-gray-600 break-words">
//                   <p className="hidden md:block">
//                     {showMore
//                       ? project.Banner_Description
//                       : `${project.Banner_Description?.substring(0, 100)}...`}
//                   </p>
//                   <p className="block md:hidden">
//                     {showMore
//                       ? project.Banner_Description
//                       : `${project.Banner_Description?.substring(0, 50)}...`}
//                   </p>
//                 </div>

//                 {/* Actions */}
//                 <div className="flex items-center justify-between mt-3 border-t pt-3">
//                   <button
//                     onClick={() => setShowMore((old) => !old)}
//                     className="text-sm text-red-500 hover:text-[#DB0029]"
//                   >
//                     {project?.Banner_Description?.length > 99 &&
//                       (showMore ? "Show less" : "Show more")}
//                   </button>
//                   <div className="flex gap-2 text-xs md:text-base">
//                     <Link
//                       to={`/${servicesWorkforceList}/${project._id}`}
//                       className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 transition duration-150 rounded-lg"
//                     >
//                       <FaRegEdit size={20} />
//                     </Link>
//                     {user === "admin" && (
//                       <button
//                         id={project._id}
//                         onClick={handleDelete}
//                         className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 transition duration-150 rounded-lg"
//                       >
//                         <MdDeleteForever size={23} />
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </>
//           ) : (
//             <Link
//               to={`/${servicesWorkforceListAdd}`}
//               className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
//             >
//               <p className="text-8xl group-hover:text-[#DB0029]">
//                 <AiFillFileAdd />
//               </p>
//             </Link>
//           )}
//         </div>
//       ) : null}
//     </>
//   );
// }

// export default WorkforceCard;


function WorkforceCard({ project, user, handleSingleDelete, dragHandle }) {
  const { servicesWorkforceList, servicesWorkforceListAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);
  const cardImage = project?.Content_Image?.url || project?.Banner_image?.url;

  const handleDelete = async () => {
    const res = await handleSingleDelete?.(project._id);
    if (res === true) {
      setVisibility(false);
    }
  };

  return visibility ? (
    <div className="group relative border md:min-h-[20rem] flex flex-col overflow-hidden shadow-lg rounded-lg h-full bg-white">
      {project ? (
        <>
          {/* Image */}
          <div className="relative">
            <figure className="relative">
              {/* Drag Handle on top-left of image */}
              {dragHandle && dragHandle}
              <img
                src={`${process.env.REACT_APP_API_URL}images/${cardImage}`}
                alt={project.Content_Title + " Image"}
                className="h-[120px] md:h-[180px] object-cover w-full"
              />
            </figure>
          </div>

          {/* Content */}
          <div className="p-4 flex flex-col flex-grow justify-between gap-3">
            {/* Title Section */}
            <div>
              <span className="block text-sm md:text-base font-medium text-gray-900">
                {project.Content_Title}
              </span>
              <h2 className="mt-1 text-base md:text-lg font-semibold break-words">
                {project?.Banner_Title?.length > 20 && !showMore ? (
                  <>
                    {project?.Banner_Title?.substring(0, 25)}
                    <button
                      onClick={() => setShowMore(true)}
                      className="text-red-600 hover:text-[#DB0029] ml-1"
                    >
                      ...
                    </button>
                  </>
                ) : (
                  <>
                    {project?.Banner_Title}
                    {project?.Banner_Title?.length > 20 && (
                      <button
                        onClick={() => setShowMore(false)}
                        className="text-red-600 hover:text-[#DB0029] ml-2 text-sm"
                      >
                        Show less
                      </button>
                    )}
                  </>
                )}
              </h2>
            </div>

            {/* Description */}
            <div className="text-gray-600 break-words">
              <p className="hidden md:block">
                {showMore
                  ? project.Banner_Description
                  : `${project.Banner_Description?.substring(0, 100)}...`}
              </p>
              <p className="block md:hidden">
                {showMore
                  ? project.Banner_Description
                  : `${project.Banner_Description?.substring(0, 50)}...`}
              </p>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-between mt-3 border-t pt-3">
              <button
                onClick={() => setShowMore((old) => !old)}
                className="text-sm text-red-500 hover:text-[#DB0029]"
              >
                {project?.Banner_Description?.length > 99 &&
                  (showMore ? "Show less" : "Show more")}
              </button>
              <div className="flex gap-2 text-xs md:text-base">
                <Link
                  to={`/${servicesWorkforceList}/${project._id}`}
                  className="btn btn-outline btn-xs text-blue-500 hover:text-blue-700 transition duration-150 rounded-lg"
                >
                  <FaRegEdit size={20} />
                </Link>
                {user === "admin" && (
                  <button
                    id={project._id}
                    onClick={handleDelete}
                    className="btn btn-outline btn-xs text-red-500 px-3 hover:text-red-700 transition duration-150 rounded-lg"
                  >
                    <MdDeleteForever size={23} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <Link
          to={`/${servicesWorkforceListAdd}`}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full"
        >
          <p className="text-8xl group-hover:text-[#DB0029]">
            <AiFillFileAdd />
          </p>
        </Link>
      )}
    </div>
  ) : null;
}

export default WorkforceCard;
